/**
 * Authors: mariushirjanu
 * Created: 11/06/2021
 */
import { Component } from '@angular/core';
import { IContact } from '../../../../type_definitions/datatypes';
import { IRoleContact } from '../../webshop/info/webshop-info-data.service';
import { GaMessageService } from '../../../shared/message/ga-message.service';

import { RoleContactType } from '../../../shared/contact/role-contact-type';

@Component({
  selector: 'contact-info-demo',
  template: `
    <h3>Contact</h3>
    <contact-info [contact]="contact"></contact-info>
    <br/><br/>
    <h3>Role contact</h3>
    <contact-info [roleContact]="roleContact"></contact-info>
    <br/><br/>
    <h3>Dialog</h3>
    <button class="btn btn-primary" (click)="openDialog()">Open dialog</button>
  `
})
export class ContactInfoDemoComponent {
  public contact:IContact;
  public roleContact:IRoleContact;

  constructor(
    private messageService:GaMessageService
  ) {
    this.contact = {
      id: 27953,
      firstname: 'Sonya',
      lastname: 'Wells',
      title: 'Project manager',
      email: 'sonya.wells@oracle.com',
      officePhone: '00 44 118 924 6899',
      cellPhone: '00 44 7831 624467',
      fullName: 'Sonya Wells',
      company: 'ORACLE',
      country: 'UNITED KINGDOM',
      companyCountryId: 19048,
      creationDate: 1202338800000,
      active: true,
      linkedIn: 'https://www.linkedin.com/in/sonya.wells',
      preferredCommunication: 'linkedin',
      lastLoginDate: 1325153200000,
      trainingStatus: {
        id: 'AUTONOMOUS',
        value: 'Autonomous'
      },
      comments: 'Some comments about the user'
    };

    this.roleContact = {
      creationDate: 1325113200000,
      creationUserName: 'Marius Hirjanu',
      contactType: RoleContactType.CGAM,
      contact: this.contact
    };
  }

  public openDialog():void {
    this.messageService.showDialog({
      component: ContactInfoDemoComponent,
      inputs: {
        contact: this.contact,
        roleContact: this.roleContact
      },
      initialState: {
        title: 'Contact info dialog',
        closeButton: true
      }
    });
  }
}